import { Box, Button, Card, Container, CssBaseline, Typography } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import quickPayService from "../http/quickpay.service";

const PaymentSuccess: React.FC<{}> = () => {
  const { search } = useLocation();
  useEffect(()=>{
    if(search){
      const query = new URLSearchParams(search);
      if(query && query.get('transaction')){
        const transactionId = query.get('transaction');
        quickPayService.paymentSuccess(transactionId).then(r=>{});
      }
    }
  },[search]);
  return (
    <Container sx={{ maxWidth: "lg", pt: 4 }}>
      <Card sx={{ p: 2, borderRadius: '1rem'}}>
        <CssBaseline />
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
          <Typography variant="h4" color="primary" sx={{fontWeight: 600}}>Thank you for your Payment!</Typography>
          <Typography sx={{mt: 4}}>If you have any questions, please contact us at: 239-345-8001 or info@primemedteam.com</Typography>
          <Button sx={{mt: 4}} href="https://primemedteam.com" variant="outlined" startIcon={<HomeIcon />}>
            Back to Prime Medical Group
          </Button>
        </Box>
      </Card>
    </Container>
  );
};

export default PaymentSuccess;
